import { Children } from 'react';
import { isFragment } from 'react-is';

var flattenChildren = function flattenChildren(children) {
  return Children.toArray(children).reduce(function (acc, child) {
    if (isFragment(child)) {
      return acc.concat(flattenChildren(child.props.children));
    }

    acc.push(child);
    return acc;
  }, []);
};

export { flattenChildren };